import { createRootRoute, Outlet } from "@tanstack/react-router";
import { CookieConsent } from "@/components/legal/cookie-consent";

export const Route = createRootRoute({
	component: RootLayout,
});

/** Экраны входа центрируются на канве — карточка 400px по макету 4a. */
function RootLayout() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-page p-4">
			<Outlet />
			{/*
			  Баннер cookie — плашка внизу, а не оверлей: он обязан быть виден на
			  форме входа И не мешать читать юридический документ на `/legal/*`
			  (GDPR: согласие спрашивают, не запирая доступ к тексту, по которому
			  его дают). Контейнер `min-h-screen`, а не `h-screen`, поэтому
			  длинный документ растит страницу, а не обрезается центрированием.
			*/}
			<CookieConsent />
		</div>
	);
}
